import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  Autocomplete,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { UseGeneralPages } from "../UseGeneralPages";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../../components/ProgressCom";
import Detail from "../../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsProgress, rsActiveMenu } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import ThisPageContent from "./content/ThisPageContent";
import Contacts from "./contact/Contacts";
import PageFAQ from "./FAQ/PageFAQ";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function PageDetail() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedState, setSelectedState] = useState(
    location.state && location.state.scrollTo ? location.state.scrollTo : ""
  );
  const [brand, setBrand] = useState();
  const { GetGeneralPagesByID, UpdateGeneralPage } = UseGeneralPages();
  const [state, setState] = useState({
    id: undefined,
    metaDescription: undefined,
    pagename: undefined,
    title: undefined,
    contacts: [],
    contents: [],
    images: [],
    faq: [],
    showFAQ: false,
    showContent: false,
    showContact: false,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (location.state && location.state.id) {
      setProgress(true);
      GetGeneralPagesByID(location.state.id, (callback) => {
        setState(callback);
      });
    }
  }, [location.state]);

  useEffect(() => {
    if (selectedState) {
      const element = document.getElementById(selectedState);
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 2000);
    }
  }, [selectedState]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/generalpages",
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/generalpages" },
          {
            name: "ویرایش صفحه",
            url: "/generalpages/pageDetail",
          },
        ],
      }}
    >
      {!brand ? (
        <Box
          sx={{ p: 2 }}
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gap={2}
        >
          <Box gridColumn={isSmall ? "span 12" : "span  2"}>
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.id ? state.id : ""}
              sx={{
                input: { textAlign: "center" },
              }}
              label="ردیف"
              size="small"
              variant="filled"
              onChange={(evt) => {
                setState({ ...state, id: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  3"}>
            <TextField
              fullWidth
              value={state.pagename ? state.pagename : ""}
              label="نام صفحه"
              size="small"
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              variant="filled"
              onChange={(evt) => {
                setState({ ...state, pagename: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  3"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              label="عنوان صفحه"
              size="small"
              variant="filled"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box id="Content" gridColumn="span 12">
            <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
              توضیحات متا :{" "}
            </Typography>
            <TextField
              fullWidth
              value={state.metaDescription ? state.metaDescription : ""}
              multiline
              maxRows={5}
              onChange={(evt) => {
                if (
                  evt.target.value.length < 151 ||
                  evt.target.value.length < state.metaDescription.length
                ) {
                  setState({ ...state, metaDescription: evt.target.value });
                  return;
                } else {
                  setState({
                    ...state,
                    metaDescription: state.metaDescription,
                  });
                  enqueueSnackbar("بیشتر از مقدار مجاز (150 کاراکتر)", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
              }}
              size="small"
              variant="outlined"
            />
          </Box>
          <Box sx={{ mx: "auto" }} gridColumn="span 12">
            <Button
              sx={{ width: "70px" }}
              color="secondary"
              variant="contained"
              onClick={() => {
                let newState = {
                  id: state.id,
                  metaDescription: state.metaDescription,
                };
                UpdateGeneralPage(newState, (callback) => {});
              }}
            >
              ثبت
            </Button>
          </Box>
          {state.showContent && (
            <Box id="PageContent" gridColumn="span 12">
              <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
                محتوای صفحه :{" "}
              </Typography>
              <ThisPageContent
                refresh={(generalID) => {
                  setProgress(true);
                  GetGeneralPagesByID(generalID, (callback) => {
                    setState(callback);
                  });
                }}
                image={state.images ? state.images : []}
                data={state.contents ? state.contents : []}
                GeneralID={state.id && state.id}
              />
            </Box>
          )}
          {state.showContact && (
            <Box id="PageContact" gridColumn="span 12">
              <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
                اطلاعات تماس :{" "}
              </Typography>
              <Contacts
                refresh={(generalID) => {
                  setProgress(true);
                  GetGeneralPagesByID(generalID, (callback) => {
                    setState(callback);
                  });
                }}
                data={state.contacts ? state.contacts : []}
                GeneralID={state.id && state.id}
              />
            </Box>
          )}
          {state.showFAQ && (
            <Box id="PageFAQ" gridColumn="span 12">
              <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
                سوالات متداول:
              </Typography>
              <PageFAQ
                refresh={(generalID) => {
                  setProgress(true);
                  GetGeneralPagesByID(generalID, (callback) => {
                    setState(callback);
                  });
                }}
                data={state.faq ? state.faq : []}
                GeneralID={state.id && state.id}
              />
            </Box>
          )}
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
